(function () {
  var MOBILE_QUERY = window.matchMedia('(max-width: 699px)');

  function buildAccordion(title, contentNode) {
    var wrapper = document.createElement('accordion-disclosure');
    wrapper.className = 'accordion';

    var details = document.createElement('details');
    details.className = 'accordion__disclosure group';
    details.setAttribute('aria-expanded', 'false');

    var summary = document.createElement('summary');
    var toggle = document.createElement('span');
    toggle.className = 'accordion__toggle h6';

    var titleSpan = document.createElement('span');
    titleSpan.textContent = title;

    var plus = document.createElement('span');
    plus.className = 'animated-plus group-expanded:rotate';
    plus.setAttribute('aria-hidden', 'true');

    toggle.appendChild(titleSpan);
    toggle.appendChild(plus);
    summary.appendChild(toggle);

    var content = document.createElement('div');
    content.className = 'accordion__content';
    content.appendChild(contentNode);

    details.appendChild(summary);
    details.appendChild(content);
    wrapper.appendChild(details);

    return wrapper;
  }

  function initFooterAccordion() {
    var footerSection = document.querySelector('.shopify-section--footer');
    if (!footerSection) return;

    if (footerSection.querySelector('.footer__block-list--mobile')) return;

    var blockList = footerSection.querySelector('.footer__block-list');
    if (!blockList || blockList.classList.contains('th-footer-accordion-ready')) return;

    var linkBlocks = blockList.querySelectorAll('.footer__block--static_links, .footer__block--links');
    if (!linkBlocks.length) return;

    var accordionGroup = document.createElement('div');
    accordionGroup.className = 'footer__accordion-group accordion-group';

    linkBlocks.forEach(function (block) {
      var stack = block.querySelector('.v-stack');
      if (!stack) return;

      var titleEl = stack.querySelector('.h6');
      if (!titleEl) return;

      var title = titleEl.textContent.trim();
      var contentFragment = document.createDocumentFragment();

      Array.prototype.slice.call(stack.children).forEach(function (child) {
        if (child === titleEl) return;
        contentFragment.appendChild(child.cloneNode(true));
      });

      var contentWrap = document.createElement('div');
      contentWrap.appendChild(contentFragment);

      accordionGroup.appendChild(buildAccordion(title, contentWrap));
      block.remove();
    });

    blockList.appendChild(accordionGroup);
    blockList.classList.add('th-footer-accordion-ready');
  }

  function sync() {
    if (MOBILE_QUERY.matches) {
      initFooterAccordion();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  MOBILE_QUERY.addEventListener('change', sync);
})();
